import { api } from "./api";

let _cache = null;
let _cachePromise = null;

const DEFAULTS = {
  name: "Clean Manager USA",
  phone: "",
  email: "",
  address: "",
  website: "",
  instagram: "",
  facebook: "",
  whatsapp: "",
  tagline: "",
};

/**
 * Fetch the company settings (cached in memory for the SPA session).
 * Returns a safe object even on error.
 */
export async function getCompanySettings() {
  if (_cache) return _cache;
  if (_cachePromise) return _cachePromise;
  _cachePromise = api
    .get("/company-settings")
    .then((r) => {
      _cache = { ...DEFAULTS, ...(r.data || {}) };
      _cachePromise = null;
      return _cache;
    })
    .catch(() => {
      _cachePromise = null;
      return DEFAULTS;
    });
  return _cachePromise;
}

/** Force refresh (called from CompanySettings page after PUT). */
export function clearCompanyCache() {
  _cache = null;
  _cachePromise = null;
}

/** Build a multi-line contact block for PDFs (returns string array). */
export function companyContactLines(c) {
  const out = [];
  if (c.phone) out.push(`Tel: ${c.phone}`);
  if (c.whatsapp) out.push(`WhatsApp: ${c.whatsapp}`);
  if (c.email) out.push(c.email);
  if (c.address) out.push(c.address);
  if (c.website) out.push(c.website);
  const socials = [c.instagram, c.facebook].filter(Boolean).join(" · ");
  if (socials) out.push(socials);
  return out;
}
